import React from "react"
import PropTypes from "prop-types"

import { searchifySelectGenericFilter, toggleGenericFilter } from "shared/search/containers/Filter/FilterCreators"

import {
    SupporterFilterableListView,
    BulkSMSFilterableListView,
    CampaignFilterableListView,
} from "shared/search/containers/FilterableListView/FilterableListViews"
import { datePickerGenericFilter } from "shared/search/containers/Filter/Filters"

import { ContactSelect, BulkSMSSelect, CampaignSelect } from "app/static/frontend/selects/containers/PieSelect"

const dateDefaultPropTypes = {
    displayLabel: PropTypes.string,
    filterComponent: PropTypes.func,
    filterKey: PropTypes.string,
    uniqueFilterId: PropTypes.string,
    helpText: PropTypes.string,
    noFuture: PropTypes.bool,
}

export const SendSMSContactFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent searchifyFLV={SupporterFilterableListView} {...props} />
}

SendSMSContactFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    dataTypeLabel: PropTypes.string,
    selectComponent: PropTypes.func,
}

SendSMSContactFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "SendSMSContactFilter",
    filterKey: "about_supporter",
    dataTypeLabel: "Contacts",
    selectComponent: ContactSelect,
}

export const SendSMSTextFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent searchifyFLV={BulkSMSFilterableListView} {...props} />
}

SendSMSTextFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "SendSMSTextFilter",
    filterKey: "about_text",
    dataTypeLabel: "Texts",
    selectComponent: BulkSMSSelect,
    searchifyPermanentFilter: {
        current_status: DjangIO.app.texting.types.TextDeliveryStatus.sent.value,
    },
}

export const SendSMSStatusClickedFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent {...props} />
}

SendSMSStatusClickedFilter.defaultProps = {
    filterComponent: toggleGenericFilter,
    uniqueFilterId: "SendSMSStatusClickedFilter",
    filterKey: "opens",
    dataTypeLabel: "Status",
    displayLabel: "Clicked",
    trueText: "Yes",
    falseText: "No",
}

export const SendSMSStatusConvertedFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent {...props} />
}

SendSMSStatusConvertedFilter.defaultProps = {
    filterComponent: toggleGenericFilter,
    uniqueFilterId: "SendSMSStatusConvertedFilter",
    filterKey: "converted",
    dataTypeLabel: "Status",
    displayLabel: "Converted",
    trueText: "Yes",
    falseText: "No",
}

export const SendSMSReceivedStatusFilter = (props) => {
    const FilterComponent = props.filterComponent || toggleGenericFilter
    return <FilterComponent searchifyFLV={BulkSMSFilterableListView} {...props} />
}

SendSMSReceivedStatusFilter.defaultProps = {
    filterComponent: toggleGenericFilter,
    uniqueFilterId: "SendSMSSentStatusFilter",
    filterKey: "send_sms_received_status",
    displayLabel: "Received",
    trueText: "Yes",
    falseText: "No",
}

export const SendSMSDateCreatedBeforeFilter = (props) => {
    const FilterComponent = props.filterComponent || datePickerGenericFilter
    return <FilterComponent searchifyFLV={SupporterFilterableListView} {...props} />
}
SendSMSDateCreatedBeforeFilter.propTypes = dateDefaultPropTypes
SendSMSDateCreatedBeforeFilter.defaultProps = {
    filterComponent: datePickerGenericFilter,
    uniqueFilterId: "SendSMSDateCreatedBeforeFilter",
    filterKey: "bulk_sms__sent_time__lte",
    displayLabel: "Before",
    noFuture: true,
}

export const SendSMSDateCreatedAfterFilter = (props) => {
    const FilterComponent = props.filterComponent || datePickerGenericFilter
    return <FilterComponent searchifyFLV={SupporterFilterableListView} {...props} />
}
SendSMSDateCreatedAfterFilter.propTypes = dateDefaultPropTypes
SendSMSDateCreatedAfterFilter.defaultProps = {
    filterComponent: datePickerGenericFilter,
    uniqueFilterId: "SendSMSDateCreatedAfterFilter",
    filterKey: "bulk_sms__sent_time__gte",
    displayLabel: "After",
    noFuture: true,
}

export const SendSMSCampaignFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent searchifyFLV={CampaignFilterableListView} {...props} />
}
SendSMSCampaignFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    dataTypeLabel: PropTypes.string,
    selectComponent: PropTypes.func,
}
SendSMSCampaignFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "SendSMSCampaignFilter",
    filterKey: "campaigns_related",
    dataTypeLabel: "Campaigns",
    selectComponent: CampaignSelect,
}
